var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer",class:{'divider': this.showDivider}},[_vm._v("Version "+_vm._s(_vm.version)+". Copyright © CPD Made Easy "+_vm._s(_vm.year))])
}
var staticRenderFns = []

export { render, staticRenderFns }